import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { Logo } from "../Logo";
import { useAppTheme } from "../../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

const LINKS = [
  { href: "/#features", label: "Features" },
  { href: "/#how-it-works", label: "How it Works" },
  { href: "/#pricing", label: "Pricing" },
  { href: "/#faq", label: "FAQ" },
];

export default function LandingNav() {
  const [open, setOpen] = useState(false);
  const { theme, toggleTheme } = useAppTheme();

  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center" data-testid="landing-logo-link">
          <Logo className="h-8" />
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <Link key={l.href} to={l.href} data-testid={`landing-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm font-medium text-muted-foreground transition-colors duration-150 hover:text-foreground">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button onClick={toggleTheme} data-testid="landing-theme-toggle" className="rounded-lg p-2 text-muted-foreground hover:bg-muted transition-colors duration-150">
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          <Link to="/login" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid="landing-nav-login">
            Sign In
          </Link>
          <Button asChild size="sm" data-testid="landing-nav-cta">
            <Link to="/signup">Start Free Trial</Link>
          </Button>
        </div>

        <button className="p-2 md:hidden" onClick={() => setOpen(!open)} data-testid="landing-mobile-menu-btn">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border/70 bg-background px-4 py-4 md:hidden animate-in fade-in-0 slide-in-from-top-2 duration-200">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} data-testid={`landing-mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm font-medium text-muted-foreground">
                {l.label}
              </Link>
            ))}
            <Link to="/login" className="text-sm font-medium text-muted-foreground" data-testid="landing-mobile-nav-login">
              Sign In
            </Link>
            <Button asChild size="sm" className="w-full" data-testid="landing-mobile-nav-cta">
              <Link to="/signup">Start Free Trial</Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
